// src/context/AuthContext.jsx
import React, { createContext, useContext, useState } from "react";
import api from "../services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [tokens, setTokens] = useState(() => {
    const stored = localStorage.getItem("tokens");
    return stored ? JSON.parse(stored) : null;
  });

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  const login = async (email, password) => {
    const response = await api.post("/auth/login", { email, password });
    setTokens(response.data);
    localStorage.setItem("tokens", JSON.stringify(response.data));

    const decoded = parseJwt(response.data.access_token);
    setUser(decoded);
    localStorage.setItem("user", JSON.stringify(decoded));
  };

  const loginWithToken = (tokenData) => {
    setTokens(tokenData);
    localStorage.setItem("tokens", JSON.stringify(tokenData));

    const decoded = parseJwt(tokenData.access_token);
    setUser(decoded);
    localStorage.setItem("user", JSON.stringify(decoded));
  };

  const logout = () => {
    setTokens(null);
    setUser(null);
    localStorage.removeItem("tokens");
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ login, loginWithToken, logout, tokens, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}
